@let e = error();
@if (e) {
  <div class="host">
    @if (e.icon) {
      <i class="fas fs-40 pb-20" [ngClass]="e.icon"></i>
    }
    @if (e.message) {
      <div [innerHTML]="e.message" class="fs-20 message"></div>
    }
  </div>
}